import type { SailingFromPackages } from '@/infra/types/voyageInfo/sailing';

import { ClassificationCode } from '@/infra/types/voyageInfo/base';
import constants from '@/tagmanager/constants';

export const takeAlmostSoldOutLabel = (sailing: SailingFromPackages) =>
  sailing?.classificationCodes?.includes(ClassificationCode.AlmostSoldOut)
    ? constants.EVENT_LABELS.ALMOST_SOLD_OUT
    : '';
